export const publicationFieldGroups = [
  'content',
  'pricing',
  'media',
  'taxonomy',
  'availability',
  'state',
];

export function parseListingIDs(value) {
  return Array.from(new Set(String(value || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean)));
}

export function managedFields(publication) {
  return Array.isArray(publication?.managed_field_groups)
    ? publication.managed_field_groups
    : [];
}

export function publicationRows(listings) {
  return (listings || []).flatMap((listing) => (listing.publications || []).map((publication) => ({
    ...publication,
    listing,
  })));
}

export function usablePlan(entry, now = Date.now()) {
  if (entry?.status !== 'planned' || !entry.plan?.id || !entry.plan?.plan_hash) return false;
  if (!entry.plan.expires_at) return true;
  const expiresAt = new Date(entry.plan.expires_at).getTime();
  return Number.isFinite(expiresAt) && expiresAt > now;
}
